import React, { useState } from 'react';
import { Tabs, Tab, Col } from 'react-bootstrap';
import "../Fundproject/fundproject.css";
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';

const Fundtabstatus = () => {
  const [key, setKey] = useState('Fundedproject');

  return (
    <>
      <div className='main-conatiner'>
        <div className='container py-4'>
          <Tabs
            id="custom-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="custom-tabs justify-content-center"
            transition={false}
          >
            <Tab eventKey="Fundedproject" title="Funded Project">

              <div className="tab-content-box mt-3">
                <div className='card'>
                  <div className="table-responsive">
                    <table className="table align-items-center table-flush">
                      <thead className="thead-light">
                        <tr>
                          <th>Action</th>
                          <th>Project ID</th>
                          <th>Project Name</th>
                          <th>Created By</th>
                          <th>Assigned To</th>
                          <th>Client (Location)</th>
                          <th>Category</th>
                          <th>Start Date (Deadline)</th>
                          <th>Status</th>
                          <th>Interested User</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div style={{ width: "120px" }}>
                              <Link to={"/view-project/101"} target="_blank">
                                <button className="viewproject-btn pull-right mb-1">
                                  <span style={{ color:"#292f36" }}>View Project</span>
                                </button>
                              </Link>
                            </div>
                          </td>

                          <td className="table-user">
                            <b>#101</b>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Company Website Revamp</b>
                              <span>Frontend + CMS</span>
                              <span>contact@clientcorp.com</span>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Vikash Jha</b>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Anjali Mehra</b>
                              <div>anjali.m@example.com</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "150px" }}>
                              <b>ClientCorp Ltd.</b>
                              <div className="text-muted">Mumbai, India</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">Corporate Website</span>
                              <span className="text-muted">React, WordPress</span>
                            </div>
                          </td>

                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">2025-06-01</span><br />
                              <span className="text-muted">Deadline: 2025-07-15</span>
                            </div>
                          </td>
                          <td>
                            <div className="project-status p-1" style={{ width: "120px" }}>
                              <span className="text-white d-flex justify-content-center">Funded</span>
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">10</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>


              <Col xs={12}>
                <div className='paginate-css'>
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={1}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={1}
                    onPageChange={() => { }}
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </Col>
            </Tab>
            <Tab eventKey="Fundapproved" title="Fund approved">

              <div className="tab-content-box mt-3">
                <div className='card'>
                  <div className="table-responsive">
                    <table className="table align-items-center table-flush">
                      <thead className="thead-light">
                        <tr>
                          <th>Action</th>
                          <th>Project ID</th>
                          <th>Project Name</th>
                          <th>Created By</th>
                          <th>Assigned To</th>
                          <th>Client (Location)</th>
                          <th>Category</th>
                          <th>Start Date (Deadline)</th>
                          <th>Status</th>
                          <th>Interested User</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div style={{ width: "120px" }}>
                              <Link to={"/view-project/101"} target="_blank">
                                <button className="viewproject-btn pull-right mb-1">
                                  <span className="text-black">View Project</span>
                                </button>
                              </Link>
                            </div>
                          </td>

                          <td className="table-user">
                            <b>#102</b>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Reactjs</b>
                              <span>Frontend + CMS</span>
                              <span>contact@clientcorp.com</span>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Vikash Jha</b>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Anjali Mehra</b>
                              <div>anjali.m@example.com</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "150px" }}>
                              <b>ClientCorp Ltd.</b>
                              <div className="text-muted">Mumbai, India</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">Corporate Website</span>
                              <span className="text-muted">React, WordPress</span>
                            </div>
                          </td>

                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">2025-06-01</span><br />
                              <span className="text-muted">Deadline: 2025-07-15</span>
                            </div>
                          </td>
                          <td>
                            <div className="project-status p-1" style={{ width: "120px" }}>
                              <span className="text-white d-flex justify-content-center">Approved</span>
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">10</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>



                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={1}
                      marginPagesDisplayed={0}
                      pageRangeDisplayed={1}
                      onPageChange={() => { }}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </div>


            </Tab>
            <Tab eventKey="fundsecured" title="Fund secured">

              <div className="tab-content-box mt-3">
                <div className='card'>
                  <div className="table-responsive">
                    <table className="table align-items-center table-flush">
                      <thead className="thead-light">
                        <tr>
                          <th>Action</th>
                          <th>Project ID</th>
                          <th>Project Name</th>
                          <th>Created By</th>
                          <th>Assigned To</th>
                          <th>Client (Location)</th>
                          <th>Category</th>
                          <th>Start Date (Deadline)</th>
                          <th>Status</th>
                          <th>Interested User</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div style={{ width: "120px" }}>
                              <Link to={"/view-project/101"} target="_blank">
                                <button className="viewproject-btn pull-right mb-1">
                                  <span className="text-black">View Project</span>
                                </button>
                              </Link>
                            </div>
                          </td>

                          <td className="table-user">
                            <b>#103</b>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Company Website Revamp</b>
                              <span>Frontend + CMS</span>
                              <span>contact@clientcorp.com</span>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Vikash Jha</b>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <b>Anjali Mehra</b>
                              <div>anjali.m@example.com</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "150px" }}>
                              <b>ClientCorp Ltd.</b>
                              <div className="text-muted">Mumbai, India</div>
                            </div>
                          </td>

                          <td className="table-user">
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">Corporate Website</span>
                              <span className="text-muted">React, WordPress</span>
                            </div>
                          </td>

                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">2025-06-01</span><br />
                              <span className="text-muted">Deadline: 2025-07-15</span>
                            </div>
                          </td>
                          <td>
                            <div className="project-status p-1" style={{ width: "120px" }}>
                              <span className="text-white d-flex justify-content-center">Secured</span>
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "120px" }}>
                              <span className="text-muted">10</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>


              </div>

              <Col xs={12}>
                <div className='paginate-css'>
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={1}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={1}
                    onPageChange={() => { }}
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </Col>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>

  );
};

export default Fundtabstatus;
